export default function Tick() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 -0.5 25 25" fill="none">
            <path d="M5.5 12.5L10.167 17L19.5 8" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}